import { css } from '@emotion/react';
import { theme } from '../../../design-system/theme/theme';

export const rowStyle = (bad: boolean) => css`
  background: ${bad ? `${theme.color.danger}08` : 'transparent'};

  &:hover {
    background: ${bad ? `${theme.color.danger}10` : theme.color.bg};
  }
`;

export const nameCellStyle = css`
  font-weight: 500;
`;

export const monoMutedStyle = css`
  font-family: ui-monospace, SFMono-Regular, Menlo, Consolas, monospace;
  font-size: ${theme.fontSize.sm}px;
  color: ${theme.color.textMuted};
`;

export const mutedStyle = css`
  color: ${theme.color.textMuted};
`;

export const dangerStyle = css`
  color: ${theme.color.danger};
`;

export const warnStyle = css`
  color: ${theme.color.warning};
  font-weight: 500;
`;

export const actionCellStyle = css`
  text-align: right;
`;
